module.exports = __webpack_public_path__ + "images/avatar.469910ac9e124498293da06c43daba48.png";